import { useAxios } from "@/app/providers/AxiosProvider";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export default function useCreateCandidateNote(candidateId) {
  const api = useAxios();
  const client = useQueryClient();

  return useMutation({
    mutationFn: (content) => {
      return api.post(`/candidate/${candidateId}/notes`, { content });
    },
    onSuccess: () => {
      client.invalidateQueries({ queryKey: ["candidateNotes", candidateId] });
    },
  });
}
